import styled from 'styled-components';
import { getColorShade, getSizeBy, getThemeProp } from '../../../../../src/styled/utils';
import { disabledDropzoneCSS, focusedUrlDropzoneCSS, hintBorderDropzoneCSS } from '../styled';
import { Button } from '../../../button';
export const InputSection = styled.span `
  display: flex;
  padding: ${getSizeBy(2)} ${getSizeBy(2)} ${getSizeBy(2)} 0;
  color: ${getColorShade('onSurface', 'border')};
  border: 1px solid ${getColorShade('onSurface', 'border')};
  border-radius: ${getThemeProp('borderRadius')}px;

  & div,
  div:hover,
  div:focus-within,
  div:active {
    margin: 0;
    color: ${getColorShade('onSurface', 'highEmphasis')};
    background-color: transparent;
    border: none;
    outline: none;
  }

  & input {
    background-color: transparent;
  }

  ${({ isFocused, disabled, hintType }) => {
    if (disabled) {
        return disabledDropzoneCSS;
    }
    if (hintType && hintType !== 'info') {
        return hintBorderDropzoneCSS;
    }
    if (isFocused) {
        return focusedUrlDropzoneCSS;
    }
}}
`;
export const UrlUploadButton = styled(Button) `
  color: ${getColorShade('onSurface', 'highEmphasis')};
  background-color: ${getColorShade('onPrimary', 'outline')};
  border: ${getSizeBy(0.25)} solid ${getColorShade('onSurface', 'border')};
  border-radius: ${getThemeProp('borderRadius')}px;

  ${InputSection}:not(:disabled):hover > && {
    background-color: ${getColorShade('primary', 'hover')};

    > span {
      background-color: transparent;
    }
  }
`;
